
define('app/board/views/queueView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/queueCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/views/queueItemView',
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		PickSummaryCollection, 
		QueueCollection,
		LeagueInstanceModel, 
		DraftStatusModel, 
		PositionColorsModel,
		QueueItemView,
		PlayerList){
	var QueueView = Backbone.View.extend({
		el: $("#playerRankingsQueueContainer"),
		
		initialize: function(options) {
			this.user = options.userModel; 
			this.pickSummaryCollection = options.pickSummaryCollection; 
			this.leagueInstance = options.leagueInstance; 
			this.draftStatus = options.draftStatus; 
			this.posColors = options.posColors; 
			this.queueCollection = options.queueCollection; 
			
			this.queueItemViews = [];
			
			//this.draftStatus.bind("change", this.renderQueue, this);
			
			//this.listenTo(this.queueCollection, 'change', this.updateDraftStatus);
			this.listenTo(this.queueCollection, 'add', this.addQueueItem);
			this.listenTo(this.queueCollection, 'remove', this.removeQueueItem);
		},
		
		render: function () {
			this.renderQueue();
			
			return this;
		},
		
		renderQueue: function() {
			this.removeAllQueueItems();
			this.addAllQueueItems();
		},
		
		addQueueItem: function(queueItem) {
			var view = new QueueItemView({
				leagueInstance: this.leagueInstance,
				user: this.user,
				pickSummaryCollection: this.pickSummaryCollection,
				posColors: this.posColors,
				queueCollection: this.queueCollection,
				queueItem: queueItem,
				draftStatus: this.draftStatus});
			//this.listenTo(team, 'change:draftPosition', this.orderChange);
			$(this.el).find('.queueTable').find('tbody').append(view.render().el);
			this.queueItemViews[queueItem.get('id')] = view;
			
			$(this.el).find('.queueTable').show();
			$(this.el).find('.emptyTable').hide();
		},
		
		removeQueueItem: function(queueItem) {
			this.queueItemViews[queueItem.get('id')].destroyView();
			delete this.queueItemViews[queueItem.get('id')];
			
			if(this.queueItemViews.length == 0){
				$(this.el).find('.queueTable').hide();
				$(this.el).find('.emptyTable').show();
			}
		},
		
		addAllQueueItems: function() {
			this.queueCollection.each(function(queueItem){
				this.addQueueItem(queueItem);
			}, this);
		},
		
		removeAllQueueItems: function() {
			_.each(this.queueItemViews, function(view, key){
				this.queueItemViews[key].destroyView();
				delete this.queueItemViews[key];
			}, this);
			
			if(this.queueItemViews.length == 0){
				$(this.el).find('.queueTable').hide();
				$(this.el).find('.emptyTable').show();
			}
		},
		
	});
	
	return QueueView;  
});